export const getFormattedDate = (setCurrentDate) => {
    const today = new Date();
    console.log("todayyyyy",today);


    const year = today.getFullYear();
    console.log("yearrrrrrr",year);


    const month = String(today.getMonth() + 1).padStart(2, '0');
    console.log("monthhhhhh",month);


    const day = String(today.getDate()).padStart(2, '0');
    console.log("dayyyyyyy",day);


    setCurrentDate(`${year}/${month}/${day}`);
};
